import { render } from "./BusinessCardCollectionItem.vue?vue&type=template&id=edfdf546&scoped=true"
import script from "./BusinessCardCollectionItem.vue?vue&type=script&lang=js"
export * from "./BusinessCardCollectionItem.vue?vue&type=script&lang=js"

import "./BusinessCardCollectionItem.vue?vue&type=style&index=0&id=edfdf546&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edfdf546"]])

export default __exports__